/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {BaseFieldViewer} from "./BaseFieldViewer";
import autobind from "autobind-decorator";
import {service as ConservationActionPhaseService} from "../../../Services/ConservationActionPhaseService";

export class ConservationActionPhaseFieldViewer extends BaseFieldViewer {
	constructor(props) {
		super(props);

		this.setInitialState({
			conservationActionPhases: []
		});
	}

	@autobind
	shouldReloadData(prevProps, prevState) {
		return this.props.Value != prevProps.Value;
	}

	@autobind
	loadData() {
		super.loadData();

		ConservationActionPhaseService.Get()
			.then((x) => {
				this.setState({conservationActionPhases: x.result});
			});
	}

	@autobind
	getConservationActionPhase() {
		return this.state.conservationActionPhases.find((x) => x.conservationActionPhaseId == this.props.Value);
	}

	@autobind
	_render() {
		return this.getConservationActionPhase() ? this.getConservationActionPhase().name : "N/A";
	}
}